import { render } from "./ModalEditarBacklog.vue?vue&type=template&id=46a389c0"
import script from "./ModalEditarBacklog.vue?vue&type=script&lang=js"
export * from "./ModalEditarBacklog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__